/** FNV-1a 32-bit — deterministic, tiny, good enough for spreading crowd slots. */
export function hash32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/**
 * Stable crowd slots. Existing assignments are retained, departed ids are released, and new ids
 * take their hashed preferred slot or the next free one. Positions therefore never shuffle when
 * someone else joins or leaves. New ids are processed in the given order (e.g. join time).
 */
export function assignSlots(
  previous: ReadonlyMap<string, number>,
  ids: readonly string[],
  slotCount: number,
): Map<string, number> {
  const next = new Map<string, number>();
  const taken = new Set<number>();
  const wanted = new Set(ids);
  for (const [id, slot] of previous) {
    if (wanted.has(id) && slot < slotCount && !taken.has(slot)) {
      next.set(id, slot);
      taken.add(slot);
    }
  }
  for (const id of ids) {
    if (next.has(id)) continue;
    if (taken.size >= slotCount) break; // overflow: caller renders a "+N" indicator
    let slot = hash32(id) % slotCount;
    while (taken.has(slot)) slot = (slot + 1) % slotCount;
    next.set(id, slot);
    taken.add(slot);
  }
  return next;
}
